/* Santas Vault - make the mobile menu drawer an accordion.
 *
 * THE PROBLEM. Horizon's drawer renders every submenu expanded inline, so on a
 * phone the menu was one flat list of eight top level items and all thirty
 * four children: about 1,400 px of scrolling before you reach the last thing.
 * That is the same fault as the endless collection scroll, in the one place a
 * shopper goes when they already know they are lost.
 *
 * THE FIX, and the constraint it works around. The top level entries are real
 * links to real shelves, so they must stay tappable; turning the parent into a
 * toggle would take "Personalised" away as a destination. So each parent that
 * has children gains a SEPARATE chevron button beside it. Tap the words to go
 * to the shelf, tap the chevron to see what is under it. One section open at a
 * time, and the section for the page you are on opens itself.
 *
 * It runs on the drawer markup as Horizon renders it, so it degrades to the
 * old flat list if those class names ever change rather than breaking the menu.
 */
(function () {
  'use strict';
  try { window.__svMenu = { loaded: Date.now(), state: document.readyState }; } catch (e) {}

  var PARENT = '.menu-drawer__list-item--flat';
  var CHILD = '.menu-drawer__menu--childlist';
  var MAIN = '.menu-drawer__menu-item--mainlist';

  function chevron() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sv-subtoggle';
    b.setAttribute('aria-expanded', 'false');
    b.innerHTML =
      '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">' +
      '<path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  function build(root) {
    var items = root.querySelectorAll(PARENT);
    if (!items.length) return false;

    Array.prototype.forEach.call(items, function (li) {
      if (li.dataset.svAccordion) return;
      var sub = li.querySelector(CHILD);
      var main = li.querySelector(MAIN);
      if (!sub || !main) return;
      li.dataset.svAccordion = '1';
      li.classList.add('sv-has-sub');

      var btn = chevron();
      // Name the control for a screen reader: "Show what is under Personalised"
      var label = (main.textContent || '').trim();
      btn.setAttribute('aria-label', 'Show what is under ' + label);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = li.classList.contains('is-open');
        // one open at a time: a phone menu with three sections open is the
        // flat list again with extra steps
        Array.prototype.forEach.call(items, function (other) {
          other.classList.remove('is-open');
          var ob = other.querySelector('.sv-subtoggle');
          if (ob) ob.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          li.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      main.insertAdjacentElement('afterend', btn);

      // open the section that contains the page we are on
      var here = window.location.pathname;
      if (here && here !== '/' && sub.querySelector('a[href^="' + here + '"]')) {
        li.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    root.classList.add('sv-accordion-ready');
    return true;
  }

  // Returns true only when the accordion is actually BUILT, not merely when the
  // nav element exists. The first fix watched for the nav and disconnected the
  // observer the moment it appeared - but Horizon streams the nav in before its
  // list items, so build() found nothing, reported success, and the observer
  // stopped watching a second before the menu arrived.
  function init() {
    var d = document.querySelector('.menu-drawer__navigation');
    try { window.__svMenu.tries = (window.__svMenu.tries || 0) + 1; window.__svMenu.nav = !!d; } catch (e) {}
    if (!d) return false;
    return build(d) === true;
  }

  // WHY THIS KEEPS GOING AFTER IT SUCCEEDS. Three attempts went in before this
  // one and every one failed silently, which is the interesting part:
  //   1. DOMContentLoaded alone ran while the header was still streaming.
  //   2. A MutationObserver never fired a second time.
  //   3. A poll that stopped on first success ALSO produced nothing, and the
  //      probe said it had succeeded on attempt one.
  // Which is the answer. The drawer IS decorated at parse time, and then
  // Horizon re-renders the header and throws the decoration away. No event is
  // raised for that. So the job is not "run once when the drawer appears", it
  // is "keep the drawer decorated". The tick is cheap, build() is idempotent
  // through the dataset guard, and it re-decorates within 400 ms of any
  // re-render.

  // ---------------------------------------------------------------- hover
  // THE DESKTOP DROPDOWNS ONLY OPENED ON A CLICK. Horizon drives the mega menu
  // from a `button.menu-list__disclosure` carrying `aria-expanded`, and nothing
  // in the theme opens it on hover, so on a laptop you had to click a shelf
  // name, wait, then click again to actually go there. Every store a shopper
  // has used opens these on hover.
  //
  // This does NOT reimplement the dropdown. It clicks Horizon's own button, so
  // the theme's animation, focus handling and outside-click close all still run
  // exactly as written. Doing it in CSS was tried first and does not work: the
  // panel is height-constrained as well as faded, and the height comes from the
  // expanded state, not from a hover rule.
  //
  // Guards that matter: pointer devices only, so a tap on a tablet is not
  // turned into a hover that never ends; a small close delay, because the gap
  // between the trigger and the panel would otherwise slam it shut as the mouse
  // travels; and only above the drawer breakpoint, because below it there is no
  // bar to hover.
  var HOVER_MIN = 1220, CLOSE_MS = 220;

  function canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
           window.innerWidth >= HOVER_MIN;
  }

  function hoverInit() {
    if (!canHover()) return;
    var items = document.querySelectorAll('.menu-list__list-item');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (li.dataset.svHover) continue;
      var btn = li.querySelector('.menu-list__disclosure');
      if (!btn) continue;
      li.dataset.svHover = '1';
      (function (li, btn) {
        var timer = null;
        li.addEventListener('mouseenter', function () {
          if (!canHover()) return;
          clearTimeout(timer);
          if (btn.getAttribute('aria-expanded') !== 'true') btn.click();
        });
        li.addEventListener('mouseleave', function () {
          if (!canHover()) return;
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (btn.getAttribute('aria-expanded') === 'true') btn.click();
          }, CLOSE_MS);
        });
      })(li, btn);
    }
  }

  function start() {
    init();
    hoverInit();
    var tries = 0;
    var t = setInterval(function () {
      tries += 1;
      init();
      hoverInit();
      if (tries > 50) clearInterval(t);     // twenty seconds, then stop
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function () { init(); hoverInit(); });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.menu-drawer-container summary')) {
      setTimeout(init, 60);
    }
  }, true);
})();
